import { motion } from "framer-motion"

const BOTTLE = "https://static.lumi.new/2b/2b7c1575a442a2046f6f1ef956afe145.webp"

function Fragrance() {
  return (
    <section id="fragrance" className="relative w-full bg-[#080808] px-8 py-32 md:px-16 md:py-40 lg:px-28">
      <motion.p
        className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1 }}
      >
        05
      </motion.p>
      <motion.p
        className="font-sans-ui mt-4 text-[11px] tracking-[0.4em] text-stone-500"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.1 }}
      >
        限定香氛
      </motion.p>

      <div className="mt-10 grid w-full items-center gap-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="relative overflow-hidden bg-[#111111]">
            <motion.img
              src={BOTTLE}
              alt="馴養一朵風"
              className="mx-auto h-[72vh] w-full object-cover object-center md:h-[86vh]"
              initial={{ y: 30, opacity: 0.7 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
        </div>

        <div className="lg:col-span-5">
          <motion.h2
            className="font-display text-5xl leading-tight text-[#f7f1e6] md:text-7xl"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 }}
          >
            馴養一朵風
          </motion.h2>

          <motion.div
            className="mt-8 max-w-md space-y-5 text-sm leading-8 text-stone-300"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.2, delay: 0.1 }}
          >
            <p className="font-serif-tc">
              大家好，我是一名音樂人、樂團吉他手，也是一名大學老師。這件作品的靈感來自張懸的〈玫瑰色的你〉與《小王子》的玫瑰。
            </p>
            <p className="font-serif-tc">
              我用綠茶與透明花香呈現風的乾淨自由，中間藏入玫瑰，最後以木質、麝香與淡淡焚香，留下時間沉澱的味道。
            </p>
            <p className="font-serif-tc">我將它命名為《馴養一朵風》。</p>
            <p className="font-serif-tc">
              因為風無法被留住，就像有些人終究會離開。但真正的連結不是佔有，而是相遇之後，即使離開了，依然改變了你。
            </p>
            <p className="font-serif-tc italic text-[#c4a574]">風走了，味道卻留下了。</p>
          </motion.div>

          <motion.div
            className="mx-auto mt-10 max-w-xs space-y-3 border-t border-white/10 pt-8 text-center"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, delay: 0.15 }}
          >
            <p className="font-sans-ui text-sm tracking-[0.28em] text-stone-300">
              Perfumer｜邱鉦耀
            </p>
            <p className="font-sans-ui text-sm tracking-[0.28em] text-stone-400">
              10 ml Eau de Parfum
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Fragrance
